﻿$.fn.dxCtrlContentComEnvoiStat = function custom_dxCtrlContentComEnvoiStat(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-dxctrlcontentcomenvoistat dx-ctrl");
        this.createInstance(new cdxCtrlContentComEnvoiStat(this, option));
    }
    return this;
}

window.cdxCtrlContentComEnvoiStat = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    var dxTitle = null
    //var dxChartResume = null
    var dxBounce = null
    var dxVue = null
    var dxClick = null
    var dxReac = null
    var dxResumeClick = null
    var dxHistoEnvoiVueClick = null
    var dxNewResumeEnvoi = null
    var jauge = null
    var $DivDashBoard = null
    function mConstruit() {
        container.empty()
        jauge = $("<div/>").appendTo(container).dxCtrlJauge({}).dxCtrlJauge("instance")
        //jauge.mShow()


        var $DivEntete = $("<div style='padding:0 10%;'/>").appendTo(container)
        var $Table = $("<table style='width:100%;border-bottom:" + theme.border + ";'/>").appendTo($DivEntete)
        var $Tr = $("<tr/>").appendTo($Table)
        //var $Td = $("<td style='width:0px;" + ((option.data.date_envoi == null) ? "display:none;" : "") + "'/>").appendTo($Tr)
        //if (page.isPhone) $Td.hide()
        //$("<div/>").appendTo($Td).dxCtrlButton({
        //    icon: 'fas fa-sync-alt',
        //    txtTooltip: "Rafraîchir les statistiques",
        //    onClick: function () {
        //        mUpdate(true);
        //        //mNotify("Les statistiques ont été rafraichies", "success", 3000)
        //    }
        //})
        var $Td = $("<td style='width:100%'/>").appendTo($Tr)
        dxTitle = $("<div style='padding:10px;width:100%;'/>").appendTo($Td).dxCtrlChartTitleEnvoi({
            bddCtrl: option.bddCtrl,
            data: option.data
        }).dxCtrlChartTitleEnvoi("instance")
        dxTitle.mStartUpdate()
        var $Tr = $("<tr/>").appendTo($Table)
        if (typeof option.bddCtrl.utiCourantParaJson.parametre_general.affichewarningrobotvueclic == 'undefined') option.bddCtrl.utiCourantParaJson.parametre_general.affichewarningrobotvueclic = true
        if (option.bddCtrl.utiCourantParaJson.parametre_general.affichewarningrobotvueclic) {
            var $Td = $("<td style='width:100%;font-family:barlow condensed;'/>").appendTo($Tr)
            var dxWarningForm = $("<div style='margin:5px'/>").appendTo($Td).dxCtrlWarningForm({
                type: "info",
                contentTemplate: function (contentElement) {
                    $("<div class='dxwarningformtext' style='font-family:barlow condensed;'>Contrairement aux logiciels d’emailing classiques, " + parametre.nom + " <b> exclut les ouvertures et les clics générés par les robots</b> afin de vous fournir des statistiques plus représentatives des <b> interactions humaines</b>.Vos résultats peuvent donc être moins flatteurs qu’avec d’autres outils, mais ils reflètent plus fidèlement la réalité.<br/> De cette manière, vos relances s'appuie sur de vrai vue et clicks.<br/>Vous pouvez voir les vues et clics des robots en activant l'option des robots sur les listes.</div>").appendTo(contentElement)
                    var $A = $("<a href='javascript:void(0)'>J'ai compris (ne plus afficher)</a>").appendTo(contentElement)
                    $A.on("click", function (e) {
                        option.bddCtrl.utiCourantParaJson.parametre_general.affichewarningrobotvueclic = false
                        option.bddCtrl.mSaveParaJsonUtilisateur();
                        dxWarningForm.hide()
                    })
                }
            }).dxCtrlWarningForm("instance")
        }

        //$("<div style='height:20px'/>").appendTo($DivEntete)

        if (option.data.nb_dest_total - option.data.nb_dest_envoye > 0) {
            function mUpdateData() {
                window.setTimeout(function () {
                    mUpdate(true)
                    mUpdateData()
                }, 10000)
            }
            mUpdateData()
        }

        var $DivSpam = $("<div style='width:100%;text-align:center;vertical-align:top;'/>").appendTo($DivEntete)
        if (option.type == "email" && option.data.nb_spam > 0) {
            if (option.data.nb_spam_bascule != null) {
                if (option.data.nb_spam_bascule2 != null) {
                    $("<div style='color:red'>⚠ " + option.data.nb_spam + " messages mise en SPAM par vos destinataires ⚠</div>").appendTo($DivSpam)
                    //$("<div style='opacity:0.4'>Vous avez dépassé le taux de SPAM au cours de votre envoi, et vous avez ensuite eu à nouveau une mise en SPAM</div>").appendTo($DivSpam)
                } else {
                    $("<div style='color:orange'>⚠ " + option.data.nb_spam + " messages mise en SPAM par vos destinataires ⚠</div>").appendTo($DivSpam)
                    //$("<div style='opacity:0.4'>Vous avez dépassé le taux de SPAM au cours de votre envoi</div>").appendTo($DivSpam)
                }
            } else {
                $("<div style='color:green'>" + option.data.nb_spam + " messages mise en SPAM par vos destinataires</div>").appendTo($DivSpam)
                //$("<div style='opacity:0.4'>Votre taux de SPAM par rapport à vos envois est resté en dessous de la limite autorisé</div>").appendTo($DivSpam)
            }
        }

        if (option.bddCtrl.getObjet(option.data).mGetTable().nom == "com_email_envoi" && option.data.nb_dest_total - option.data.nb_dest_envoye == 0) {
            var $aAjoutDestEmail = $("<a href='javascript:void(0)'><i class='fas fa-square-envelope'></i> Générer un emailing avec des destinataires du mailing</a>").appendTo($DivEntete)
            $aAjoutDestEmail.css("margin-left", "15px")
            $aAjoutDestEmail.attr("title", "Créer un emailing avec les destinataires (tous ou seulement destinataire annulé, en erreur, vue, click...).")
            $aAjoutDestEmail.on("click", function (e) {
                $("<div/>").appendTo("body").dxCtrlPopupSelectDestinataireMailing({
                    bddCtrl: option.bddCtrl,
                    id: option.bddCtrl.getObjet(option.data).cle(),
                    title:"Pour qui créer un emailing ?",
                    showAddRemove: false,
                    onValide: function (lstIdTableId, selectRetire) {
                        switch (selectRetire) {
                            case "Ajouter les destinataires":
                                var lst = []
                                lstIdTableId.forEach(function (item) {
                                    lst.push({ id_table: item.id_table_destinataire, id: item.id_destinataire })
                                })
                                jaugeDemarrage.mShow()
                                option.bddCtrl.mAjaxCall({
                                    command: "getdestwithcoord",
                                    type: "email",
                                    lstnewdestcom: lst
                                }, function (data) {
                                    if (typeof data.lstdest == 'undefined') data.lstdest = []
                                    var obj = option.bddCtrl.getObjet("com_email_envoi")
                                    obj.objetMetier.mCreateEmailBrouillon("", "", [], data.lstdest, null, false, null, false, null, true, "", function (id_com_email_envoi) {
                                        obj = option.bddCtrl.getObjet("com_email_envoi", id_com_email_envoi)
                                        obj.mShowPopup()
                                        jaugeDemarrage.mHide()
                                    })
                                })
                                break;
                            case "Retirer les destinataires":
                                throw new Error("NotImplementedException")
                                break;
                        }
                    }
                })
            })
        }

        $DivDashBoard = $("<div style='height:calc(100% - " + $DivEntete.innerHeight() + "px)'/>").appendTo(container)

        resizeObserver.mAdd($DivEntete, function () { $DivDashBoard.css("height", "calc(100% - " + $DivEntete.innerHeight() + "px)"); })

        mRempliDashBoard()

    }

    var dxDashBoard = null
    function mRempliDashBoard() {
        var opt = {
            bddCtrl: option.bddCtrl,
            idTableCom: option.bddCtrl.getObjet(option.data).mGetTable().id_table,
            idCom: option.bddCtrl.getObjet(option.data).cle()
        }
        switch (option.type) {
            case "email":
                opt.context_grid = "dashboardcomemailtracking"
                opt.selectedKey = "email"
                opt.lstKeyHided = ["bdd", "doccpt_devis", "doccpt_commande", "doccpt_facture", "sms", "email_repartvue", "email_repartclick", "email_repartreactivite", "sms_repartvue", "sms_repartclick", "sms_repartreactivite"]
                opt.data = JSON.parse('[{"x":0,"y":0,"w":4,"h":4,"key":"email_vue"},{"x":4,"y":0,"w":4,"h":4,"key":"email_click"},{"x":8,"y":0,"w":4,"h":4,"key":"email_reactivite"},{"x":12,"y":0,"w":8,"h":14,"key":"email_resumeenvoitunnel"},{"x":0,"y":4,"w":6,"h":4,"key":"email_liste_bounce"},{"x":6,"y":4,"w":6,"h":4,"key":"email_liste_noire"},{"x":0,"y":8,"w":12,"h":5,"key":"email_resumeenvoi"},{"x":0,"y":13,"w":12,"h":11,"key":"email_histoenvoivueclick"},{"x":12,"y":14,"w":8,"h":10,"key":"email_toplstclick"}]')
                break;
            case "sms": case "mobile":
                opt.context_grid = "dashboardcomsmstracking"
                opt.selectedKey = "sms"
                opt.lstKeyHided = ["bdd", "doccpt_devis", "doccpt_commande", "doccpt_facture", "email", "email_repartvue", "email_repartclick", "email_repartreactivite", "sms_repartvue", "sms_repartclick", "sms_repartreactivite"]
                opt.data = JSON.parse('[{"x":0,"y":0,"w":4,"h":4,"key":"sms_vue"},{"x":4,"y":0,"w":4,"h":4,"key":"sms_click"},{"x":8,"y":0,"w":4,"h":4,"key":"sms_reactivite"},{"x":12,"y":0,"w":8,"h":14,"key":"sms_resumeenvoitunnel"},{"x":0,"y":4,"w":6,"h":4,"key":"sms_liste_bounce"},{"x":6,"y":4,"w":6,"h":4,"key":"sms_liste_noire"},{"x":0,"y":8,"w":12,"h":5,"key":"sms_resumeenvoi"},{"x":0,"y":13,"w":12,"h":11,"key":"sms_histoenvoivueclick"},{"x":12,"y":14,"w":8,"h":10,"key":"sms_toplstclick"}]')
                //opt.data = JSON.parse('[{"x":0,"y":0,"w":15,"h":6,"key":"sms_resumeenvoi"},{"x":15,"y":0,"w":5,"h":6,"key":"sms_reactivite"},{"x":0,"y":6,"w":10,"h":10,"key":"sms_toplstclick"},{"x":10,"y":6,"w":5,"h":5,"key":"sms_vue"},{"x":15,"y":6,"w":5,"h":5,"key":"sms_click"},{"x":10,"y":11,"w":5,"h":5,"key":"sms_liste_bounce"},{"x":15,"y":11,"w":5,"h":5,"key":"sms_liste_noire"},{"x":0,"y":16,"w":20,"h":9,"key":"sms_histoenvoivueclick"}]')
                break;
        }
        dxDashBoard = $("<div/>").appendTo($DivDashBoard).dxCtrlDashBoard(opt).dxCtrlDashBoard("instance")
    }

    function mUpdate(all) {
        if (container.closest("body").length == 0) return
        option.bddCtrl.mAjaxCall({
            command: "getresumeenvoi",
            id_table_com: option.bddCtrl.getObjet(option.data).mGetTable().id_table,
            id_com: option.bddCtrl.getObjet(option.data).cle()
        }, function (data) {
            data = data.stat[0]
            dxTitle.mUpdate(data)
            if (data != null && data.nb_attente > 0) {
                window.setTimeout(function () { mUpdate(all) }, 5000)
            }
        })
        if (all) dxDashBoard.mUpdate()
    }

    this.element = function () { return container }
    this.focus = function () { }

    mConstruit();
}